import { motion } from "framer-motion";
import Chapter from "./Chapter";
import { MODULES } from "@/lib/data";

export default function ModulesSlab() {
  return (
    <section className="relative py-14 md:py-20 hairline-t">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Chapter number="07" label={"Full platform \u00B7 9 modules"} />

        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="font-display text-[36px] md:text-[54px] leading-[1.04] tracking-[-0.022em] text-balance mb-10 max-w-[24ch]"
        >
          Everything you need. Nothing you don't.
        </motion.h2>

        <div className="machined overflow-hidden">
          {MODULES.map((m, i) => (
            <motion.div
              key={m.code}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.04, ease: [0.22,1,0.36,1] }}
              className="group grid grid-cols-12 items-center gap-6 px-6 md:px-8 py-6 border-b border-[color:var(--hairline)] last:border-b-0 hover:bg-[color:var(--hairline)] transition-colors"
            >
              <span className="col-span-2 md:col-span-1 font-mono text-[11px] tracking-[0.22em] text-ink-muted tabular">{m.code}</span>
              <span className="col-span-10 md:col-span-4 font-display text-[20px] md:text-[24px] tracking-[-0.01em]">{m.name}</span>
              <span className="col-span-12 md:col-span-7 text-ink-muted text-[14px] md:text-[15px] leading-relaxed">{m.copy}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
